const LINK_FACEBOOK = 'facebook';
const LINK_INSTAGRAM = 'instagram';
const LINK_X = 'x';
const LINK_TIKTOK = 'tiktok';
const LINK_OTHER = 'other';
const LINK_WEBSITE = 'website';

export { LINK_FACEBOOK, LINK_INSTAGRAM, LINK_X, LINK_TIKTOK, LINK_OTHER, LINK_WEBSITE };
